import { LocalizationProvider } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import ConfirmDialogProvider from "context/ConfirmDialog";
import MenuPopoverProvider from "context/MenuPopover";
import PermissionsProvider from "context/PermissionsProvider";
import UserProfileProvider from "context/UserProfile";
import { useEffect } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { io } from "socket.io-client";
import "styles/app.css";
import useNotifications from "./NotificationWrapper";
import { getApp } from "utils/helpers";
import AppProfileProvider from "context/AppProfile";
import DemoProfileProvider from "context/DemoProfile";

export let socket: any;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  useNotifications();

  const Currentapp = getApp();
  // console.log('Currentapp::', Currentapp);

  const url = window.location.href;
  const elem = document.querySelector('body') as HTMLElement;
  if (url.indexOf('?' + 'isIframe=') != -1) {
    elem.classList.add("nestedIframe");
  } else {
    elem.classList.remove('nestedIframe');
  }

  useEffect(() => {
    socket = io(process.env.REACT_APP_API_URL || "");
  }, []);

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <QueryClientProvider client={queryClient}>
          <ConfirmDialogProvider>
            <MenuPopoverProvider>
              <PermissionsProvider>
                <DemoProfileProvider>
                  <UserProfileProvider>
                    <AppProfileProvider>
                      <Currentapp />
                    </AppProfileProvider>
                  </UserProfileProvider>
                </DemoProfileProvider>
              </PermissionsProvider>
            </MenuPopoverProvider>
          </ConfirmDialogProvider>
        </QueryClientProvider>
      </LocalizationProvider>
      <ToastContainer />
    </>
  );
}

export default App;
